import { Location } from '@angular/common';
import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../../shared/services/auth.service';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'dynamica-page-not-found',
    templateUrl: './page-not-found.component.html',
    styleUrls: ['./page-not-found.component.scss'],
    imports: [TranslatePipe],
})
export class PageNotFoundComponent {
  authService = inject(AuthService);
  
  private router = inject(Router);
  private location = inject(Location);
  private oidcSecurityService = inject(OidcSecurityService);

  isLoggedIn = false;

  constructor() {
    this.oidcSecurityService.isAuthenticated$.subscribe(
      ({ isAuthenticated }) => {
        this.isLoggedIn = isAuthenticated;
      },
    );
  }

  goBack(): void {
    this.router.navigate(['/pages/revenue-manager']);
  }

  gotologin(): void {
    this.authService.logout();
  }
}
